// extracted by mini-css-extract-plugin
module.exports = {"pollContainerPreview":"PollWorldCup_pollContainerPreview__aQzIr"};